import React from 'react';
import "./style.css"

/**
*  SVG used to display a "previous arrow".
*  Displays a dark grey left-arrow "<" on a white box with rounded corners and grey border.
*/
const PrevPageSVG = ({ width = 12, height = 6 }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 1L2 7L8 13" stroke="#808C9C" strokeWidth="2" />
    </svg>

  );
}

/**
*  SVG used to display a "next arrow".
*  Displays a dark grey right-arrow ">" on a white box with rounded corners and grey border.
*/
const NextPageSVG = ({ width = 12, height = 6 }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 13L7 7L0.999999 0.999999" stroke="#808C9C" strokeWidth="2" />
    </svg>

  );
}

/**
*  SVG used to display a "next arrow".
*  Displays a dark grey right-arrow ">" on a white box with rounded corners and grey border.
*/
const BracketArrowRightSVG = ({ color = "#808C9C", width = 12, height = 6 }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 13L7 7L0.999999 0.999999" stroke={color} strokeWidth="2" />
    </svg>

  );
}


/**
*  SVG used to display a "back arrow".
*  Displays a dark grey left-arrow "<-". Used e.g. in the detail views.
*/
const BackArrowSVG = () => {
  return (
    <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.54183 10L1.5835 6.04167L5.54183 2.08333" stroke="#808C9C" strokeWidth="1.7" strokeLinecap="square" />
      <path d="M13 6L3 6" stroke="#808C9C" strokeWidth="1.7" strokeLinecap="square" />
    </svg>

  );
}

const NextArrowSVG = ({ width = 12, height = 12 }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginLeft: "5px" }}>
      <path d="M8.45817 2L12.4165 5.95833L8.45817 9.91667" stroke="#808C9C" strokeWidth="1.7" strokeLinecap="square" />
      <path d="M1 6L11 6" stroke="#808C9C" strokeWidth="1.7" strokeLinecap="square" />
    </svg>
  );
}

/**
*  SVG used to display a blue "next arrow".
*  Displays a blue right-arrow ">". Used e.g. in the Dashboard.
*/
const NextArrowBlueSVG = () => {
  return (
    <div>
      <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginTop: "-4px" }}>
        <path d="M10.8748 2.66666L15.9641 7.94443L10.8748 13.2222" stroke="#0D276B" strokeWidth="2.2" strokeLinecap="square" />
        <path d="M1.28564 8H14.1428" stroke="#0D276B" strokeWidth="2.2" strokeLinecap="square" />
      </svg>
    </div>

  );
}

/**
*  SVG used to display a blue "down arrow".
*  Displays a down facing white right-arrow ">". Used e.g. in the Devices Details .
*/
const DropdownArrowSVG = ({ width = 14, height = 9, color = "white" }) => {
  return (

    <svg style={{ marginLeft: "9px" }} width={width} height={height} viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 1L7 7L13 1" stroke={color} strokeWidth="2" />
    </svg>


  );
}


/**
*  SVG used to label Devices (e.g. in the Dashboard)
*  Displays a white "Laptop" on a blue box with rounded corners.
*/
const DeviceSVG = () => {
  return (
    <div>
      <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="30" height="30" rx="4" fill="#0F57A6" />
        <path d="M7.5 16.6667V9.24603C7.5 8.78296 7.67559 8.33885 7.98816 8.0114C8.30072 7.68396 8.72464 7.5 9.16667 7.5H20.8333C21.2754 7.5 21.6993 7.68396 22.0118 8.0114C22.3244 8.33885 22.5 8.78296 22.5 9.24603V16.6667" stroke="white" strokeWidth="1.4" strokeMiterlimit="10" strokeLinecap="square" />
        <path d="M17.9166 18.3333V19.5833H12.0833V18.3333H5.83325V19.5833C5.83325 20.3569 6.14054 21.0988 6.68752 21.6457C7.2345 22.1927 7.97637 22.5 8.74992 22.5H21.2499C22.0235 22.5 22.7653 22.1927 23.3123 21.6457C23.8593 21.0988 24.1666 20.3569 24.1666 19.5833V18.3333H17.9166Z" stroke="white" strokeWidth="1.4" strokeMiterlimit="10" strokeLinecap="square" />
      </svg>

    </div>
  );
}

/**
*  SVG used to label Scan Coverage (e.g. in the Dashboard)
*  Displays a white "Radar" on a blue box with rounded corners.
*/
const ScanSVG = () => {
  return (
    <div>
      <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="30" height="30" rx="4" fill="#0F57A6" />
        <path d="M15.0001 19.2667C17.3565 19.2667 19.2667 17.3564 19.2667 15C19.2667 12.6436 17.3565 10.7333 15.0001 10.7333C12.6437 10.7333 10.7334 12.6436 10.7334 15C10.7334 17.3564 12.6437 19.2667 15.0001 19.2667Z" stroke="white" strokeWidth="1.4" strokeMiterlimit="10" strokeLinecap="square" />
        <path d="M15 23C19.4183 23 23 19.4183 23 15C23 10.5817 19.4183 7 15 7C10.5817 7 7 10.5817 7 15C7 19.4183 10.5817 23 15 23Z" stroke="white" strokeWidth="1.4" strokeMiterlimit="10" strokeLinecap="square" />
        <path d="M15.0001 15.5333C15.2947 15.5333 15.5335 15.2945 15.5335 15C15.5335 14.7054 15.2947 14.4666 15.0001 14.4666C14.7056 14.4666 14.4668 14.7054 14.4668 15C14.4668 15.2945 14.7056 15.5333 15.0001 15.5333Z" stroke="white" strokeWidth="1.4" strokeMiterlimit="10" strokeLinecap="square" />
        <path d="M15.0001 15.5333C15.2947 15.5333 15.5335 15.2945 15.5335 15C15.5335 14.7054 15.2947 14.4666 15.0001 14.4666C14.7056 14.4666 14.4668 14.7054 14.4668 15C14.4668 15.2945 14.7056 15.5333 15.0001 15.5333Z" fill="white" />
      </svg>
    </div>
  );
}


/**
*  SVG used to label Compliance Violations (e.g. in the Filter)
*  Displays a white "C" on a blue box with rounded corners.
*/
const ComplicanceViolationLabelSVG = ({ value = 30 }) => {
  return (
    <div>
      <svg width={value} height={value} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="30" height="30" rx="4" fill="#0F57A6" />
        <path d="M20.3022 13.3079C19.9219 10.5611 17.8089 8.96733 15.0682 8.96733C11.8384 8.96733 9.40554 11.3217 9.40554 15.3182C9.40554 19.3086 11.8082 21.669 15.0682 21.669C18.0082 21.669 19.9581 19.7674 20.3022 17.407L18.0444 17.3949C17.7607 18.8438 16.5774 19.6587 15.0984 19.6587C13.0941 19.6587 11.6573 18.1555 11.6573 15.3182C11.6573 12.5291 13.082 10.9776 15.1044 10.9776C16.6076 10.9776 17.7848 11.8288 18.0444 13.3079H20.3022Z" fill="white" />
      </svg>

    </div>
  );
}

/**
*  SVG used to label Vulnerabilities (e.g. in the Filter)
*  Displays a white "V" on a blue box with rounded corners.
*/
const VulnerabilityLabelSVG = ({ value = 30 }) => {
  return (
    <svg width={value} height={value} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="30" height="30" rx="4" fill="#0F57A6" />
      <path d="M11.3736 9.13636H8.91655L13.2692 21.5H16.0341L20.3928 9.13636H17.9297L14.718 18.8679H14.5913L11.3736 9.13636Z" fill="white" />
    </svg>

  );
}

/**
*  SVG used to label Threats (e.g. in the Filter)
*  Displays a white "T" on a blue box with rounded corners.
*/
const ThreatLabelSVG = ({ value = 30 }) => {
  return (
    <svg width={value} height={value} viewBox="0 0 23 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect y="3" width="23" height="23" rx="4" fill="#0F57A6" />
      <path d="M8.22088 11.598H10.9183V19H12.4865V11.598H15.1839V10.2727H8.22088V11.598Z" fill="white" />
    </svg>
  )
}

/**
*  SVG used to label Incidents (e.g. in the Filter)
*  Displays a white "I" on a blue box with rounded corners.
*/
const IncidentLabelSVG = ({ value = 30 }) => {
  return (
    <svg width={value} height={value} viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="23" height="23" rx="4" fill="#0F57A6" />
      <path d="M12.4998 7.27273H10.9189V16H12.4998V7.27273Z" fill="white" />
    </svg>

  )
}

const SeperatorSVG = ({ value = 22 }) => {
  return (
    <svg width="23" height="20" viewBox="0 0 23 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0)">
        <path d="M13.6245 3.58325L19.8447 9.93308L13.6245 16.2829" stroke="#B5C1CE" strokeWidth="2.2" strokeLinecap="square" />
        <path d="M1.90479 10H17.6191" stroke="#B5C1CE" strokeWidth="2.2" strokeLinecap="square" />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="22" height="19.25" fill="white" transform="translate(0.333252 0.375)" />
        </clipPath>
      </defs>
    </svg>
  )
}

const LetterIcon = ({ letter, value = 30 }) => {
  return (
    <div className="icon" style={{ width: value, height: value }}>
      <p style={{ fontSize: value === 30 ? "17px" : "14px" }}>
        {letter}</p>
    </div>
  )
}

const SettingsIcon = () => {
  return (
    <svg width="23" height="24" viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.2516 0C13.1106 0 13.9338 0.335875 14.5303 0.934659C15.1268 1.53344 15.4525 2.33954 15.4251 3.09352L15.437 3.27073C15.4585 3.44446 15.517 3.61355 15.6112 3.76875C15.7961 4.07451 16.1004 4.29688 16.4523 4.38606C16.8043 4.47524 17.1825 4.42428 17.5261 4.2216L17.7241 4.122C18.4453 3.79377 19.2671 3.74016 20.027 3.97177C20.787 4.20339 21.4297 4.70335 21.8282 5.37284L22.5703 6.62369C22.5897 6.65654 22.6068 6.69058 22.6216 6.72561L22.6908 6.85996C23.0102 7.52014 23.0779 8.26891 22.8819 8.97302C22.686 9.67713 22.239 10.2909 21.6206 10.7051L21.3104 10.8951C21.147 11.0051 21.0122 11.1499 20.9096 11.3236C20.7247 11.6305 20.6746 11.9954 20.7688 12.3405C20.8631 12.6856 21.0945 12.9775 21.4465 13.1744L21.6493 13.3018C22.2601 13.7164 22.7015 14.328 22.8936 15.0275C23.0012 15.4207 23.0275 15.8307 22.971 16.2339C22.9145 16.637 22.7763 17.0253 22.5644 17.3763L21.765 18.6677L21.6457 18.8495C20.7068 20.1583 18.885 20.5602 17.4939 19.7807L17.3292 19.6996C17.1574 19.6255 16.9713 19.5838 16.8043 19.5792C16.6226 19.5779 16.4424 19.6119 16.2745 19.6791C16.1065 19.7464 15.954 19.8455 15.826 19.9707C15.6934 20.1013 15.5893 20.2565 15.5198 20.427C15.4503 20.5975 15.4169 20.7799 15.4215 20.9632L15.412 21.1694C15.3464 21.9409 14.9844 22.6602 14.3978 23.1846C13.8112 23.7089 13.043 24 12.2456 24H10.7495C8.99573 24 7.57241 22.6194 7.5736 20.9702L7.56167 20.793C7.53901 20.614 7.47805 20.4416 7.38271 20.2868C7.20137 19.9799 6.90191 19.7564 6.54996 19.6649C6.19801 19.5734 5.8222 19.622 5.4607 19.827L5.24595 19.9429C4.52195 20.258 3.70277 20.2991 2.94918 20.058C2.1956 19.8169 1.56204 19.3111 1.17286 18.6399L0.408109 17.3335L0.305507 17.1412C-0.398396 15.7004 0.153988 13.9678 1.55225 13.1848L1.67991 13.1072C2.05333 12.8559 2.27644 12.4424 2.27644 12C2.27644 11.5182 2.01158 11.0734 1.54867 10.814L1.36136 10.6982C0.706645 10.2536 0.248114 9.58622 0.076823 8.82861C-0.0944682 8.07099 0.0340094 7.27854 0.436743 6.60863L1.22416 5.35431C1.63925 4.64973 2.32456 4.13312 3.13055 3.91723C3.93653 3.70133 4.79777 3.80367 5.52632 4.20191L5.68738 4.2853C5.85202 4.35827 6.03098 4.39765 6.20278 4.3988C6.96157 4.3988 7.57957 3.80813 7.5915 3.04951V2.81787C7.65816 2.05009 8.01932 1.33458 8.60348 0.812963C9.18764 0.291343 9.95224 0.00162782 10.7459 0.00115817L12.2516 0ZM12.2516 1.73728H10.7555C10.3892 1.73728 10.0396 1.87858 9.77956 2.13107C9.55867 2.34399 9.4197 2.62403 9.38586 2.92443L9.36915 3.29042C9.30718 4.06608 8.94565 4.79039 8.35695 5.31829C7.76825 5.84619 6.99585 6.1387 6.19443 6.13725C5.74625 6.13115 5.3047 6.0312 4.89997 5.84422L4.66732 5.72493C4.50777 5.63667 4.33181 5.57995 4.14957 5.55804C3.96733 5.53612 3.78242 5.54946 3.60552 5.59726C3.42861 5.64507 3.26321 5.7264 3.11885 5.83657C2.97448 5.94675 2.85402 6.08357 2.76439 6.23917L1.97698 7.49349C1.61668 8.10038 1.79802 8.87405 2.35518 9.25162L2.67134 9.44619C3.10163 9.72865 3.45392 10.1093 3.6973 10.5548C3.94068 11.0003 4.0677 11.4969 4.06721 12.0012C4.06721 13.0146 3.5542 13.962 2.66776 14.5561L2.47925 14.6719C1.85887 15.0194 1.61787 15.7745 1.90659 16.3675L1.97459 16.4834L2.73815 17.7597C2.91711 18.0724 3.21776 18.304 3.57329 18.4025C3.87457 18.4873 4.19669 18.4693 4.48597 18.3515L4.60528 18.289C5.33304 17.8767 6.19801 17.7643 7.01167 17.9763C7.82534 18.1882 8.51731 18.7059 8.92772 19.4008C9.14844 19.7622 9.28802 20.1652 9.34291 20.6285L9.36677 21.0524C9.40409 21.3822 9.56546 21.687 9.81996 21.9084C10.0745 22.1298 10.4042 22.2523 10.7459 22.2523H12.242C12.965 22.2523 13.5544 21.7126 13.6224 21.0513L13.6296 20.9204C13.626 20.1004 13.9588 19.3128 14.5566 18.7314C15.1543 18.15 15.9644 17.828 16.8305 17.8315C17.2553 17.8431 17.6716 17.9357 18.0987 18.121L18.4805 18.311C19.0806 18.5658 19.7929 18.3805 20.1544 17.8778L20.2427 17.7446L21.0229 16.4706C21.2078 16.1637 21.258 15.7965 21.1637 15.4537C21.0853 15.1612 20.9059 14.9036 20.6555 14.7241L20.5195 14.6395C20.1576 14.4378 19.8405 14.1684 19.5865 13.847C19.3326 13.5255 19.1468 13.1583 19.0401 12.7667C18.9325 12.3764 18.9054 11.9694 18.9603 11.5689C19.0151 11.1684 19.1509 10.7824 19.3598 10.433C19.5901 10.0427 19.9086 9.70679 20.3202 9.42882L20.5147 9.30953C21.1351 8.95744 21.3737 8.20461 21.0873 7.6093L21.0014 7.44947L20.9859 7.41473L20.2773 6.22179C20.1198 5.95477 19.8731 5.74806 19.5779 5.63597C19.2828 5.52389 18.957 5.51319 18.6547 5.60564L18.5199 5.65776L18.3946 5.71914C18.036 5.92455 17.6391 6.05915 17.2268 6.1152C16.8144 6.17125 16.3947 6.14765 15.9918 6.04575C15.5896 5.94453 15.2118 5.76733 14.8802 5.52428C14.5486 5.28123 14.2695 4.9771 14.0591 4.62928C13.8321 4.25429 13.6906 3.83646 13.6439 3.40392L13.6284 3.10279C13.6403 2.73912 13.4971 2.38471 13.2347 2.12528C12.9722 1.86584 12.6143 1.71759 12.2385 1.71759L12.2516 1.73728ZM11.5095 8.07837C12.0481 8.06582 12.5839 8.15798 13.0852 8.34943C13.5866 8.54088 14.0434 8.82776 14.4289 9.19318C14.8143 9.5586 15.1206 9.99517 15.3297 10.4772C15.5387 10.9592 15.6463 11.477 15.6462 12C15.646 12.523 15.5381 13.0407 15.3287 13.5227C15.1194 14.0046 14.8129 14.441 14.4272 14.8062C14.0415 15.1714 13.5845 15.458 13.083 15.6492C12.5815 15.8403 12.0457 15.9322 11.5071 15.9193C10.457 15.8885 9.46058 15.4618 8.72919 14.7297C7.99779 13.9975 7.58896 13.0176 7.58943 11.9977C7.58989 10.9779 7.99962 9.99828 8.73168 9.26679C9.46375 8.53529 10.4606 8.10943 11.5107 8.07953L11.5095 8.07837ZM11.5095 9.81566C10.9129 9.8155 10.3407 10.0454 9.91868 10.4549C9.4967 10.8643 9.25955 11.4197 9.25939 11.9988C9.25923 12.578 9.49608 13.1335 9.91783 13.5432C10.3396 13.9528 10.9117 14.183 11.5083 14.1832C11.8037 14.1833 12.0962 14.1269 12.3692 14.0172C12.6421 13.9075 12.8902 13.7467 13.0991 13.544C13.3081 13.3413 13.4738 13.1006 13.5869 12.8356C13.7001 12.5707 13.7583 12.2868 13.7584 12C13.7585 11.7132 13.7004 11.4292 13.5874 11.1643C13.4744 10.8993 13.3088 10.6585 13.1 10.4557C12.8911 10.2528 12.6432 10.0919 12.3703 9.98211C12.0974 9.87229 11.8049 9.81573 11.5095 9.81566Z" fill="#0D276B" />
    </svg>

  )
}

const DarkModeIcon = () => {
  return (
    <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M21.819 12.3635L21.8495 12.3519L21.8665 12.3439C21.8705 12.3434 21.8763 12.3429 21.8835 12.3429C21.891 12.3428 21.8992 12.3432 21.9076 12.3441C21.9159 12.345 21.9236 12.3464 21.93 12.3479C21.9302 12.3479 21.9304 12.348 21.9306 12.348C21.9724 12.3862 21.9958 12.4241 22.0071 12.451C22.0102 12.4585 22.0121 12.4644 22.0133 12.4685L22.0127 12.4712L22.0091 12.4953C21.3364 17.0301 17.6603 20.5312 13.1705 21.0599C7.57857 21.7184 2.56162 17.7585 1.90317 12.1665C1.37529 7.68353 3.91954 3.29138 8.06833 1.49342C8.10143 1.48183 8.12074 1.47859 8.1287 1.47765C8.13136 1.47734 8.13308 1.47723 8.13407 1.47721C8.14242 1.47962 8.18006 1.49332 8.25441 1.552C8.3104 1.5962 8.33999 1.64246 8.35307 1.67377C8.35622 1.68131 8.35812 1.68716 8.35926 1.69131L8.35701 1.70217L8.35285 1.73455C8.23919 2.61925 8.23255 3.49524 8.33447 4.36087C8.97409 9.79279 13.8369 13.631 19.2688 12.9914C20.1344 12.8895 20.9849 12.6795 21.819 12.3635Z" stroke="#0D276B" strokeWidth="1.7" />
    </svg>

  )
}

const LogoutIcon = () => {
  return (
    <svg width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.15 7C13.15 7.46944 13.5306 7.85 14 7.85C14.4694 7.85 14.85 7.46944 14.85 7H13.15ZM14.85 16.5C14.85 16.0306 14.4694 15.65 14 15.65C13.5306 15.65 13.15 16.0306 13.15 16.5H14.85ZM4 1.85H11V0.15H4V1.85ZM11 21.15H4V22.85H11V21.15ZM1.85 19V4H0.15V19H1.85ZM13.15 4V7H14.85V4H13.15ZM13.15 16.5V19H14.85V16.5H13.15ZM4 21.15C2.81259 21.15 1.85 20.1874 1.85 19H0.15C0.15 21.1263 1.8737 22.85 4 22.85V21.15ZM11 22.85C13.1263 22.85 14.85 21.1263 14.85 19H13.15C13.15 20.1874 12.1874 21.15 11 21.15V22.85ZM11 1.85C12.1874 1.85 13.15 2.81259 13.15 4H14.85C14.85 1.8737 13.1263 0.15 11 0.15V1.85ZM4 0.15C1.8737 0.15 0.15 1.8737 0.15 4H1.85C1.85 2.81259 2.81259 1.85 4 1.85V0.15Z" fill="#0D276B" />
      <path d="M8.75 11.75H22.25" stroke="#0D276B" strokeWidth="1.7" strokeMiterlimit="10" strokeLinecap="round" stroke-linejoin="round" />
      <path d="M17.75 7.25L22.25 11.75L17.75 16.25" stroke="#0D276B" strokeWidth="1.7" strokeMiterlimit="10" strokeLinecap="round" stroke-linejoin="round" />
    </svg>
  )
}

const TenantsIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19.992 18.737L22.2 20.4C22.704 20.778 23 21.37 23 22V23H15V22C15 21.37 15.296 20.778 15.8 20.4L18.008 18.737" stroke="#0D276B" strokeWidth="1.7" strokeMiterlimit="10" />
      <path d="M19 19C17.895 19 17 18.105 17 17V16C17 14.895 17.895 14 19 14C20.105 14 21 14.895 21 16V17C21 18.105 20.105 19 19 19Z" stroke="#0D276B" strokeWidth="1.7" strokeMiterlimit="10" strokeLinecap="square" />
      <path d="M5.992 5.737L8.2 7.4C8.704 7.778 9 8.37 9 9V10H1V9C1 8.37 1.296 7.778 1.8 7.4L4.008 5.737" stroke="#0D276B" strokeWidth="1.7" strokeMiterlimit="10" />
      <path d="M5 6C3.895 6 3 5.105 3 4V3C3 1.895 3.895 1 5 1C6.105 1 7 1.895 7 3V4C7 5.105 6.105 6 5 6Z" stroke="#0D276B" strokeWidth="1.7" strokeMiterlimit="10" strokeLinecap="square" />
      <path d="M13 5H18C19.6569 5 21 6.34315 21 8V10" stroke="#0D276B" strokeWidth="1.7" strokeMiterlimit="10" />
      <path d="M16 2L13 5L16 8" stroke="#0D276B" strokeWidth="1.7" strokeMiterlimit="10" strokeLinecap="square" />
      <path d="M11 19H6C4.34315 19 3 17.6569 3 16V14" stroke="#0D276B" strokeWidth="1.7" strokeMiterlimit="10" />
      <path d="M8 22L11 19L8 16" stroke="#0D276B" strokeWidth="1.7" strokeMiterlimit="10" strokeLinecap="square" />
    </svg>
  )
}

const PrintIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0)">
        <path d="M12 7.33333C12.3682 7.33333 12.6666 7.03486 12.6666 6.66667C12.6666 6.29848 12.3682 6 12 6C11.6318 6 11.3333 6.29848 11.3333 6.66667C11.3333 7.03486 11.6318 7.33333 12 7.33333Z" fill="#0F57A6" />
        <path d="M4 2.00002V1.66669C4 1.1144 4.44772 0.666687 5 0.666687H11C11.5523 0.666687 12 1.1144 12 1.66669V2.00002" stroke="#0F57A6" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="square" />
        <path d="M3.99999 12H1.66666C1.11437 12 0.666656 11.5523 0.666656 11V6.66667C0.666656 5.95942 0.947608 5.28115 1.44771 4.78105C1.9478 4.28095 2.62608 4 3.33332 4H12.6667C13.3739 4 14.0522 4.28095 14.5523 4.78105C15.0524 5.28115 15.3333 5.95942 15.3333 6.66667V11C15.3333 11.5523 14.8856 12 14.3333 12H12" stroke="#0F57A6" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="square" />
        <path d="M11 9.33337H5C4.44772 9.33337 4 9.78109 4 10.3334V14.3334C4 14.8857 4.44772 15.3334 5 15.3334H11C11.5523 15.3334 12 14.8857 12 14.3334V10.3334C12 9.78109 11.5523 9.33337 11 9.33337Z" stroke="#0F57A6" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="square" />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

const DownloadIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 0.666687V11.3334" stroke="#0F57A6" strokeWidth="1.7" strokeMiterlimit="10" />
      <path d="M12 7.33337L8 11.3334L4 7.33337" stroke="#0F57A6" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="square" />
      <path d="M14.6667 14.6667H1.33334" stroke="#0F57A6" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="square" />
    </svg>
  )
}

const GreyShowLess = () => {
  return (
    <svg width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.0977 7.5L7.09766 1.5L1.09766 7.5" stroke="#B5C1CE" strokeWidth="2" />
    </svg>
  )
}



export {
  PrevPageSVG, NextPageSVG, BackArrowSVG, NextArrowSVG, NextArrowBlueSVG, DropdownArrowSVG,
  DeviceSVG, ScanSVG, ComplicanceViolationLabelSVG, VulnerabilityLabelSVG, ThreatLabelSVG, IncidentLabelSVG,
  SeperatorSVG, BracketArrowRightSVG, LetterIcon, SettingsIcon, DarkModeIcon, LogoutIcon, TenantsIcon, PrintIcon, DownloadIcon,
  GreyShowLess, 
}
